<template>
  <div style="height: 58vh">
    <div id="main" style="width: 100%;height: 100%;"></div>
  </div>
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
export default {
  props: {
    data: Object,
    start_: Number,
    end_: Number,
  },
  components: {},
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {
    data: {
      handler: function (val) {
        this.setOptions();
      },
      deep: true,
    },
  },
  // 方法集合
  methods: {

    setOptions() {
      if (this.chart) {
        this.chart.clear();
      } else {
        this.chart = echarts.init(document.getElementById("main"));
      }

      // debugger;
      this.yAxisData_plant = [];
      this.xEndTimeData = [];
      this.seriesData = [];
      var xType = this.data.type;
      var dataLength = this.data.list.length;
      var barHeight = 24 - dataLength;
      this.data.list.forEach((item, index) => {
        this.yAxisData_plant.push(item.plant);
        this.xEndTimeData.push(this.end_);
        let bgColor;
        item.list.forEach((listItem, listIndex) => {
          switch (listItem.colorNum) {
            case 0:
              bgColor = "rgba(0,187,255,.4)";
              break;
            case 1:
              bgColor = "#F9B83F";
              break;
            case 2:
              bgColor = "#F94953";
              break;
            case 3:
              bgColor = "rgba(255,207,107,.4)";
              break;
            default:
              bgColor = "rgba(0,187,255,.4)";
          }
          let startTime = new Date(listItem.startTime).getTime();
          let endTime = new Date(listItem.endTime).getTime();
          this.seriesData.push({
            name: listItem.item,
            value: [index, startTime, endTime],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: bgColor,
                  },
                  {
                    offset: 0.5,
                    color: "white",
                  },
                  {
                    offset: 1,
                    color: bgColor,
                  },
                ]),
              },
            },
          });
        });
      });

      let option = {
        tooltip: {
          formatter: (params) => {
            var res = "";
            var name = params.name;
            var value = params.value;
            console.log('tooltip--->', params)
            if(value instanceof Array){
              var startTime = new Date(value[1]);
              var endTime = new Date(value[2]);
              res = name + "</br>" + "开始时间：" + this.$formatDate(startTime) + "</br>" +"结束时间：" + this.$formatDate(endTime)
            }else{
              res = name
            }
            return res;
          },
        },
        grid: {
          top: 48,
          left: 190,
          right: 50,
          bottom: 50,
          // height: 300,
        },
        xAxis: {
          type: "time",
          min: this.start_,
          max: this.end_,
          scale: true,
          // position: 'top',
          splitNumber: 10,
          axisLabel: {
            show: true,
            textStyle: { color: "#ffffff" },
            interval: 0,
            margin: 15,
            fontSize: 14,
            formatter: function (value, index) {
              var date = new Date(value);
              if (xType == "time") {
                var texts = [date.getHours(), "00"].join(":");
              } else {
                var texts = [
                  date.getFullYear(),
                  date.getMonth() + 1,
                  date.getDate(),
                ].join("/");
              }
              return texts;
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(0,186,255,.6)",
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          axisLine: {
            onZero: false,
            show: true,
            lineStyle: {
              color: "rgba(0,186,255,.6)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: { color: "#ffffff" },
            fontSize: 14,
          },
          splitLine: {
            show: false,
          },
          inverse: true,
          data: this.yAxisData_plant,
        },
        series: [
          {
            type: "bar",
            barWidth: barHeight,
            barGap: "-100%",
            data: this.xEndTimeData,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#ffffff",
                  },
                  {
                    offset: 0.5,
                    color: "transparent",
                  },
                  {
                    offset: 1,
                    color: "#ffffff",
                  },
                ]),
                barBorderRadius: 20,
              },
            },
          },
          {
            type: "custom",
            zlevel: 1,
            renderItem: function (params, api) {
              var categoryIndex = api.value(0);
              var start = api.coord([api.value(1), categoryIndex]);
              var end = api.coord([api.value(2), categoryIndex]);
              // var height = api.size([0, 1])[1] * 0.6;
              var rectShape = echarts.graphic.clipRectByRect(
                {
                  x: start[0],
                  y: start[1] - barHeight / 2,
                  width: end[0] - start[0],
                  height: barHeight,
                },
                {
                  x: params.coordSys.x,
                  y: params.coordSys.y,
                  width: params.coordSys.width,
                  height: params.coordSys.height,
                }
              );

              return (
                rectShape && {
                  type: "rect",
                  shape: rectShape,
                  style: api.style(),
                }
              );
            },
            encode: {
              x: [1, 2],
              y: 0,
            },
            data: this.seriesData,
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
  // 定义属性
  data() {
    return {
      chart: null,
      seriesData: [],
      yAxisData_plant: [],
      xEndTimeData: [],
    };
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.setOptions();
  },
  beforeCreate() {}, // 生命周期 - 创建之前Î
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  }, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss' scoped>
</style>
